<template>
  <Section
    @back="$emit('back')"
    title="予算設定"
    margin
    tip-message="予算設定に戻る"
  >
    <v-layout>
      <v-flex grow><v-subheader>配信期間・予算</v-subheader></v-flex>
      <v-flex shrink
        ><v-checkbox
          v-model="showRejectedBudget"
          label="却下された案件予算も表示する"
          class="ml-2"
      /></v-flex>
    </v-layout>

    <BudgetList
      :form="form"
      :show-rejected-budget="showRejectedBudget"
      :set-pace="false"
      :display-start-date="budgetListStartTime"
      :display-end-date="budgetListEndTime"
      @closeAndEditInsertionOrder="$emit('closeAndEditInsertionOrder')"
      readonly
    />
    <v-subheader>配信ペース</v-subheader>
    <v-layout column pl-4>
      <template v-if="form.campaign.enablePacingPerBudget">
        <span>配信期間ごとに設定</span>
      </template>
      <template v-else>
        <span v-if="isEvenPace">
          配信期間内均等配信
          <span>（</span>
          <AppPercent :value="form.campaign.evenPacePercentage" />
          <span>）</span>
        </span>
        <span v-if="isDailyLimit">
          1日上限
          <AppCurrency :value="form.campaign.dailyLimitBudget" />
        </span>
      </template>
    </v-layout>
    <v-subheader>目標</v-subheader>
    <v-layout column pl-4>
      <span v-if="noGoal">設定なし</span>
      <span v-else>
        <AppUnitType :value="unitType" />:
        <AppCurrency
          v-if="form.campaign.goalType !== 'ctr'"
          :value="goalValue"
          actual-number
        />
        <span v-if="form.campaign.goalType === 'ctr'"
          >{{ goalValue * 100 }} %</span
        >
      </span>
    </v-layout>
  </Section>
</template>

<script>
import dayjs from 'dayjs'
import BudgetList from '@/components/Advertiser/Operation/IO/CampaignModalPageBudgetList'
import Section from './CampaignModalPageConfirmSection.vue'
import { BudgetPacingTypes } from '@/models/CampaignOperation'

export default {
  name: 'CampaignModalPageConfirmBudget',
  components: { BudgetList, Section },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      budgetListDisplayPeriod: {
        startDate: null,
        endDate: null,
      },
      showRejectedBudget: false,
    }
  },
  computed: {
    budgetListStartTime() {
      if (!this.budgetListDisplayPeriod.startDate) return
      return dayjs(this.budgetListDisplayPeriod.startDate).format(
        'YYYY-MM-DD 00:00:00',
      )
    },
    budgetListEndTime() {
      if (!this.budgetListDisplayPeriod.endDate) return
      return dayjs(this.budgetListDisplayPeriod.endDate).format(
        'YYYY-MM-DD 23:59:59',
      )
    },
    isEvenPace() {
      return this.form.campaign.pacingType === BudgetPacingTypes.EVEN_PACE
    },
    isDailyLimit() {
      return this.form.campaign.pacingType === BudgetPacingTypes.DAILY_LIMIT
    },
    noGoal() {
      return (
        !this.form.campaign.enableOptimization &&
        this.form.campaign.menu.unitType !== 'cpc'
      )
    },
    unitType() {
      return this.form.campaign.menu.unitType === 'cpc'
        ? 'cpc'
        : this.form.campaign.goalType
    },
    goalValue() {
      return this.form.campaign.menu.unitType === 'cpc'
        ? this.form.campaign.menu.grossPrice
        : this.form.campaign.goalValue
    },
  },
  created() {
    this.calcBudgetListPeriod()
  },
  methods: {
    calcBudgetListPeriod() {
      this.budgetListDisplayPeriod = this.form.wholePeriodOfBudgets
    },
  },
}
</script>

<style></style>
